/**
 * @generated SignedSource<<c748b3a43666ed3af4dae2db70c6d3d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrganisationRoleType = "ADMIN" | "DEVELOPER" | "WORKSPACE_USER";
export type WorkspaceRoleType = "ADMIN" | "READ_ONLY";
export type UserWorkspaceRoleInput = {
  role: WorkspaceRoleType;
  workspaceId: string;
};
export type OrgUserEditScreenSetWorkspaceRolesMutation$variables = {
  orgRole: OrganisationRoleType;
  userId: string;
  workspaceRoles: ReadonlyArray<UserWorkspaceRoleInput>;
};
export type OrgUserEditScreenSetWorkspaceRolesMutation$data = {
  readonly organisation: {
    readonly setUserWorkspaceRoles: {
      readonly user: {
        readonly email: string;
        readonly id: string;
        readonly name: string;
      };
      readonly workspaceRoles: ReadonlyArray<{
        readonly roleType: WorkspaceRoleType;
        readonly workspace: {
          readonly id: string;
          readonly name: string;
          readonly subWorkspaceCount: number;
        };
      }>;
    } | null;
  };
};
export type OrgUserEditScreenSetWorkspaceRolesMutation = {
  response: OrgUserEditScreenSetWorkspaceRolesMutation$data;
  variables: OrgUserEditScreenSetWorkspaceRolesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgRole"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceRoles"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrgMutation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "orgRole",
            "variableName": "orgRole"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          },
          {
            "kind": "Variable",
            "name": "workspaceRoles",
            "variableName": "workspaceRoles"
          }
        ],
        "concreteType": "OrgUser",
        "kind": "LinkedField",
        "name": "setUserWorkspaceRoles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserWorkspaceRole",
            "kind": "LinkedField",
            "name": "workspaceRoles",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subWorkspaceCount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roleType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgUserEditScreenSetWorkspaceRolesMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgUserEditScreenSetWorkspaceRolesMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "32960f79ab126b42c702eda1cfaa8c63",
    "id": null,
    "metadata": {},
    "name": "OrgUserEditScreenSetWorkspaceRolesMutation",
    "operationKind": "mutation",
    "text": "mutation OrgUserEditScreenSetWorkspaceRolesMutation(\n  $userId: String!\n  $workspaceRoles: [UserWorkspaceRoleInput!]!\n  $orgRole: OrganisationRoleType!\n) {\n  organisation {\n    setUserWorkspaceRoles(userId: $userId, workspaceRoles: $workspaceRoles, orgRole: $orgRole) {\n      user {\n        id\n        name\n        email\n      }\n      workspaceRoles {\n        workspace {\n          id\n          name\n          subWorkspaceCount\n        }\n        roleType\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b739ce2dc37912e7b800fe033f4fe669";

export default node;
